import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cf7a7dce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7a7dce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf7a7dce')) {
      api.createRecord('cf7a7dce', component.options)
    } else {
      api.reload('cf7a7dce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cf7a7dce&scoped=true", function () {
      api.rerender('cf7a7dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/base-data/code-rule/index.vue"
export default component.exports